<!-- Background image -->
<div
  class="absolute h-screen w-screen bg-cover bg-center"
  style="background-image: url('assets/woordkr8/backgrounds/login-background.png')"
></div>

<!-- Black background overlay -->
<div class="absolute inset-0 bg-black/50"></div>

<form class="relative flex h-screen w-screen flex-row items-center justify-center" [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="h-[483px] max-h-full w-[400px] max-w-full">
    <!-- Login panel -->
    <app-portal-panel>
      <div class="flex h-full flex-col items-center justify-around">
        <div class="flex flex-col gap-4">
          <div class="barlow-semi-condensed-bold text-center text-6xl text-white">Inloggen</div>
          <div class="barlow-regular text-center text-2xl text-white">Gebruik de spelerscode die je van school hebt gekregen.</div>
        </div>
        <!-- input -->
        <div class="flex w-xs flex-col items-center justify-center gap-8">
          <div class="flex w-full flex-col gap-4">
            <app-portal-input class="w-full" id="name" ngDefaultControl formControlName="name" placeholder="Naam"></app-portal-input>

            <app-portal-input
              class="w-full"
              id="playerCode"
              ngDefaultControl
              formControlName="playerCode"
              placeholder="Spelerscode"
              [showError]="showPlayerCodeInvalid()"
              errorMessage="Deze spelerscode klopt niet."
            ></app-portal-input>
          </div>

          <button [disabled]="form.invalid" appPortalButton class="barlow-semi-condensed-semibold h-16 w-full text-2xl" type="submit">
            Spel starten
          </button>
        </div>
      </div>
    </app-portal-panel>
  </div>
</form>

<!-- Back button -->
<button (click)="navigateToSelectDeviceType()" class="absolute top-0 left-4 w-48 transition-transform hover:scale-105" type="button">
  <img src="assets\woordkr8\sprites\back-button.png" class="object-contain" alt="Terug" />
</button>
